<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span>Filtrar productos</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="filter-card-content">
          <filter-products :brands="products.brands" :conditions="products.conditions" :price="products.price" @filterProducts="filterProducts" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import FilterProducts from '@/components/Product/FilterProducts'

export default {
  name: 'FilterProductsModal',
  components: {
    FilterProducts
  },
  props: {
    products: {
      require: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    closeModal () {
      this.isOpen = false
      this.$emit('close')
    },
    filterProducts (searchConfig) {
      this.$emit('filterProducts', searchConfig)
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.filter-card-content {
  padding: 16px !important;
}
</style>
